import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { useBackordersRowsTable, useBackordersTable } from 'src/pages/purchasing/backorders/useBackordersTable';
import DetailPanelContainer from 'src/core/tables/helpers/DetailPanelContainer';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';

export const BackordersTablePage = () => {
  const [columns, tableSettings] = useBackordersTable();
  return (
    <>
      <PageHeader title="Backorders" subTitle="Backorders" components={generateTablePageButtons(tableSettings)} />
      <ContentCardsContainer>
        <ContentCard {...{ cardTypes: [CardType.noHeader], contentPadding: 0 }}>
          <CustomDataGrid columns={columns} tableSettings={tableSettings} getDetailPanelContent={(row) => <DetailPanelContent {...{ row }} />} />
        </ContentCard>
      </ContentCardsContainer>
      <Footer />
    </>
  );
};
export default BackordersTablePage;

const DetailPanelContent = ({ row }) => {
  const [columns, tableSettings] = useBackordersRowsTable(row?.row?.DetailRows);
  return (
    <DetailPanelContainer>
      <CustomDataGrid columns={columns} tableSettings={tableSettings} />
    </DetailPanelContainer>
  );
};

